import React, { Children } from 'react';
export function PrivacyPage() {
  const handleBack = () => {
    window.location.hash = '';
  };
  return <div className="min-h-screen bg-navy-950 text-slate-100" data-id="element-276">
      <div className="max-w-4xl mx-auto px-6 py-20" data-id="element-277">
        <button onClick={handleBack} className="text-mint-500 hover:text-mint-400 mb-8 inline-flex items-center gap-2 transition-colors" data-id="element-278">
          ← Back to home
        </button>

        <div className="prose prose-invert prose-slate max-w-none" data-id="element-279">
          <h1 className="text-4xl font-bold mb-2" data-id="element-280">Privacy Policy</h1>
          <p className="text-slate-400 mb-8" data-id="element-281">Last updated: February 2, 2026</p>

          <div className="space-y-8 text-slate-300 leading-relaxed" data-id="element-282">
            <p data-id="element-283">
              Pulsewave ("Pulsewave," "we," "us") respects your privacy. This
              Privacy Policy explains how we collect, use, share, and protect
              information when you visit https://pulsewaveco.com or use our
              products and services (collectively, the "Services").
            </p>

            <section data-id="element-284">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-285">
                1. Information we collect
              </h2>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3" data-id="element-286">
                A. Information you provide
              </h3>
              <ul className="list-disc pl-6 space-y-2" data-id="element-287">
                <li data-id="element-288">
                  Phone number, which we use as your primary account identifier
                </li>
                <li data-id="element-289">
                  Optional profile information you choose to provide (such as
                  name, email address, social handles)
                </li>
                <li data-id="element-290">
                  Content you submit, including messages, feedback, or form
                  responses
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3" data-id="element-291">
                B. Authentication information
              </h3>
              <ul className="list-disc pl-6 space-y-2" data-id="element-292">
                <li data-id="element-293">
                  We send one-time passcodes (OTP) to your phone number for
                  login and account verification
                </li>
                <li data-id="element-294">
                  We may store limited authentication-related metadata (such as
                  timestamps, delivery status, device or session information) to
                  help secure accounts and prevent fraud
                </li>
                <li data-id="element-295">We do not store reusable passwords</li>
              </ul>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3" data-id="element-296">
                C. Information collected automatically
              </h3>
              <ul className="list-disc pl-6 space-y-2" data-id="element-297">
                <li data-id="element-298">
                  Device and usage information such as IP address, browser type,
                  pages viewed, referring URLs, timestamps, and interactions
                </li>
                <li data-id="element-299">
                  Cookies or similar technologies used for basic functionality
                  and analytics
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3" data-id="element-300">
                D. Information from third parties
              </h3>
              <p data-id="element-301">
                We work with third-party service providers (e.g., SMS delivery,
                hosting, analytics, customer support) who process information on
                our behalf
              </p>
            </section>

            <section data-id="element-302">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-303">
                2. How we use information
              </h2>
              <p data-id="element-304">We use the information we collect to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-305">
                <li data-id="element-306">
                  Create and manage accounts using phone-number-based login
                </li>
                <li data-id="element-307">
                  Send login passcodes and important service-related messages
                </li>
                <li data-id="element-308">Operate, maintain, and improve the Services</li>
                <li data-id="element-309">
                  Monitor usage, analyze performance, and improve user
                  experience
                </li>
                <li data-id="element-310">
                  Detect, prevent, and address fraud, abuse, or security issues
                </li>
                <li data-id="element-311">
                  Communicate with you for support and administrative purposes
                </li>
              </ul>
            </section>

            <section data-id="element-312">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-313">
                3. How we share information
              </h2>
              <p data-id="element-314">We may share information with:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-315">
                <li data-id="element-316">
                  Service providers who help us operate the Services, under
                  contractual confidentiality obligations
                </li>
                <li data-id="element-317">
                  Legal or regulatory authorities if required by law or to
                  protect rights, safety, or security
                </li>
                <li data-id="element-318">
                  Business partners or successors in connection with a merger,
                  acquisition, financing, or sale of assets
                </li>
                <li data-id="element-319">With your direction or consent</li>
              </ul>
              <p className="mt-4" data-id="element-320">
                We do not sell your personal information in the ordinary sense.
              </p>
            </section>

            <section data-id="element-321">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-322">
                4. SMS communications
              </h2>
              <p data-id="element-323">
                By providing your phone number, you consent to receive
                transactional messages, including one-time passcodes and
                account-related notifications. Message and data rates may apply.
                We do not guarantee uninterrupted or timely delivery of SMS
                messages due to carrier or network factors.
              </p>
            </section>

            <section data-id="element-324">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-325">
                5. Cookies and analytics
              </h2>
              <p data-id="element-326">
                We use cookies and similar technologies to enable core site
                functionality and understand how the Services are used. You can
                control cookies through your browser settings, though some
                features may not function properly without them.
              </p>
            </section>

            <section data-id="element-327">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-328">
                6. Data retention
              </h2>
              <p data-id="element-329">
                We retain personal information only as long as necessary to
                provide the Services, comply with legal obligations, resolve
                disputes, and enforce our agreements. We may retain aggregated
                or de-identified data for longer periods.
              </p>
            </section>

            <section data-id="element-330">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-331">
                7. Security
              </h2>
              <p data-id="element-332">
                We take reasonable administrative, technical, and physical
                measures to protect your information. However, no system is
                completely secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section data-id="element-333">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-334">
                8. Children's privacy
              </h2>
              <p data-id="element-335">
                The Services are not intended for children under the age of 13
                (or the minimum age required in your jurisdiction). We do not
                knowingly collect personal information from children.
              </p>
            </section>

            <section data-id="element-336">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-337">
                9. Your rights
              </h2>
              <p data-id="element-338">
                Depending on your location, you may have rights to access,
                correct, or delete your personal information, or to object to
                certain processing. To make a request, contact us using the
                information below.
              </p>
            </section>

            <section data-id="element-339">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-340">
                10. Changes to this policy
              </h2>
              <p data-id="element-341">
                We may update this Privacy Policy from time to time. The "Last
                updated" date will reflect the most recent changes.
              </p>
            </section>

            <section data-id="element-342">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-343">
                11. Contact us
              </h2>
              <p data-id="element-344">
                If you have questions about this Privacy Policy or our data
                practices, contact us at:{' '}
                <a href="mailto:support@pulsewaveco.com" className="text-mint-500 hover:text-mint-400" data-id="element-345">
                  support@pulsewaveco.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>;
}